import { Component } from 'react';

import { RootState } from '@iwProvider/configureStore';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { InjectedFormProps, getFormValues, reduxForm } from 'redux-form';

import styles from './SelectPhoneNumberForm.module.css';
import { LoadingSpinner } from '../../../../ui/loadingSpinner';
import {
    SEND_VERIFICATION_SMS,
    TOGGLE_ADD_PHONE_NUMBER
} from '../../IdCheckVerificationModal.actions';
import messages from '../../IdCheckVerificationModal.messages';
import { TDeserialisedPerson } from '../../IdCheckVerificationModal.types';
import { SelectPhoneNumber } from '../../selectPhoneNumber/SelectPhoneNumber';

const formConfiguration = {
    form: 'onfidoVerification'
};

const mapStateToProps = (state: RootState) => ({
    ...state.idCheckVerificationModal,
    onfidoFormValues: getFormValues('onfidoVerification')(state)
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    sendSMS: (person: TDeserialisedPerson, phoneNumber: string) =>
        dispatch({ type: SEND_VERIFICATION_SMS, person, phoneNumber }),
    toggleAddPhoneNumber: (personUID: string) =>
        dispatch({ type: TOGGLE_ADD_PHONE_NUMBER, personUID })
});

type PropsFromRedux = ReturnType<typeof mapStateToProps> &
    ReturnType<typeof mapDispatchToProps>;

type TComponentProps = {
    person: TDeserialisedPerson;
};
type TProps = PropsFromRedux & TComponentProps & InjectedFormProps;

class SelectPhoneNumberForm extends Component<TProps> {
    handleFormSubmit = (person: TDeserialisedPerson) => {
        const { onfidoFormValues } = this.props;
        // @ts-expect-error - This isn't inferring any types
        const phoneNumber = onfidoFormValues[person.uid];
        this.props.sendSMS(person, phoneNumber);
    };

    renderButtonMessage(person: TDeserialisedPerson) {
        if (person.SMSPending) {
            return (
                <LoadingSpinner
                    data-testid="onfido-loading-spinner"
                    className={styles.loading}
                />
            );
        } else if (person.idCheckStatus.includes('Verifying')) {
            return <FormattedMessage {...messages.resendMessage} />;
        }

        return <FormattedMessage {...messages.sendText} />;
    }

    render() {
        const { person, onfidoFormValues, handleSubmit, toggleAddPhoneNumber } =
            this.props;
        // @ts-expect-error - This isn't inferring any types
        const hasSelectedNumber = onfidoFormValues?.[person.uid];
        const disabledStyles = !hasSelectedNumber
            ? styles.sendSMSDisabled
            : null;
        const isVerified = person.idCheckStatus === 'Verified';

        const shouldDisablePhoneInput =
            isVerified || person.reachedMaxIdCheckAttempts;

        const shouldDisableSubmitButton =
            !hasSelectedNumber ||
            person.SMSPending ||
            isVerified ||
            person.reachedMaxIdCheckAttempts;
        return (
            <form
                onSubmit={handleSubmit(() => this.handleFormSubmit(person))}
                className={styles.SelectPhoneNumberForm}
            >
                <div className={styles.SelectPhoneNumberFormWrapper}>
                    <SelectPhoneNumber
                        name={`${person.uid}`}
                        options={person.phones}
                        disabled={shouldDisablePhoneInput}
                        addNewNumber={() => toggleAddPhoneNumber(person.uid)}
                    />

                    <button
                        type="submit"
                        disabled={shouldDisableSubmitButton}
                        className={classNames(styles.sendSMS, disabledStyles)}
                    >
                        {this.renderButtonMessage(person)}
                    </button>
                </div>
            </form>
        );
    }
}

// eslint-disable-next-line import/no-default-export
export default reduxForm<object, any>(formConfiguration)(
    connect(mapStateToProps, mapDispatchToProps)(SelectPhoneNumberForm)
);
